import { render } from "./VODScheduleTab.vue?vue&type=template&id=1832f847"
import script from "./VODScheduleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODScheduleTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODScheduleTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1832f847"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1832f847', __exports__)) {
    api.reload('1832f847', __exports__)
  }
  
  module.hot.accept("./VODScheduleTab.vue?vue&type=template&id=1832f847", () => {
    api.rerender('1832f847', render)
  })

}


export default __exports__